import { isTableType } from 'constants/chart-roles';

/**
 * Generate column ids for all columns in the column definition (using the field parameter)
 * This is required for sorting, since that's keyed to the column id
 * @param {Object} stageData - object containing documents returned from the agg pipeline, and an environment containing the chart type
 * @returns {Object} - An updated stage with columnDefs with comparators
 */
function generateColumnIds(stageData) {
  const {
    environment: { chartType },
    spec: { columnDefs },
  } = stageData;

  if (!isTableType(chartType)) {
    return {};
  }

  const newColumnDefs = columnDefs.map(parentCol => ({
    ...parentCol,
    children: parentCol.children.map(child => ({
      ...child,
      colId: child.field,
    })),
  }));

  return {
    spec: {
      ...stageData.spec,
      columnDefs: newColumnDefs,
    },
  };
}

export default {
  input: ['environment.chartType', 'spec'],
  fn: generateColumnIds,
};
